import { IAppBarConfig } from '@hooks/useWebviewCallback';

export const TRANSPARENT_APPBAR_CONFIG: IAppBarConfig = {
  back_button_color: '#FFFFFF',
  is_appbar_transparent: true,
};

export const DARK_THEME_APPBAR_CONFIG: IAppBarConfig = {
  background_color: '#121212',
  back_button_color: '#FFFFFF',
  is_appbar_transparent: false,
  status_icon_brightness: "light",
};


export const COLLECTION_HEADER_APPBAR_CONFIG: IAppBarConfig = {
  background_color: '#0a1f08',
  back_button_color: '#FFFFFF',
  is_appbar_transparent: false,
  status_icon_brightness: "light",
};

export const createAppBarConfig = (
  background_color?: string,
  back_button_color?: string,
  isTransparent: boolean = false
): IAppBarConfig => {
  const autoBackButtonColor = back_button_color || (
    background_color && isLightColor(background_color) ? '#000000' : '#FFFFFF'
  );

  return {
    ...(background_color && !isTransparent && { background_color }),
    back_button_color: autoBackButtonColor,
    is_appbar_transparent: isTransparent,
    
  };
};

function isLightColor(hexColor: string): boolean {
  const hex = hexColor.replace('#', '');
  const r = parseInt(hex.substr(0, 2), 16);
  const g = parseInt(hex.substr(2, 2), 16);
  const b = parseInt(hex.substr(4, 2), 16);
  const brightness = (r * 299 + g * 587 + b * 114) / 1000;
  return brightness > 155;
}

